import { Box, Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { getFormValues, setDataPeriodType } from 'redux/DataImportSlice';

import { FieldLabel, StepHeading, StepRadio } from '../actionStepUi';

import Single from './DataPeriod/Single';
import Multiple from './DataPeriod/Multiple';

interface Properties {
  setHelpModalSeleceted: any;
}

const DataStepsOne = ({ setHelpModalSeleceted }: Properties) => {
  const dispatch: any = useDispatch();
  const getFormValue = useSelector(getFormValues);
  return (
    <Box w='100%'>
      <StepHeading
        title='Select time period'
        subtitle='Tell us how the periods are laid out in your file.'
      />
      <FieldLabel>
        {getFormValue.dataPeriod === '2'
          ? 'Are you importing multiple time periods?'
          : 'Is your data for a single period or multiple periods?'}
      </FieldLabel>
      <Flex gap={6} pb={2}>
        <StepRadio
          isSelected={getFormValue.dataPeriod === '1'}
          onSelect={() => dispatch(setDataPeriodType('1'))}
        >
          Single
        </StepRadio>
        <StepRadio
          isSelected={getFormValue.dataPeriod === '2'}
          onSelect={() => dispatch(setDataPeriodType('2'))}
        >
          Multiple
        </StepRadio>
      </Flex>
      {getFormValue.dataPeriod === '1' && (
        <Single setHelpModalSeleceted={setHelpModalSeleceted} getFormValue={getFormValue} />
      )}
      {getFormValue.dataPeriod === '2' && (
        <Multiple setHelpModalSeleceted={setHelpModalSeleceted} getFormValue={getFormValue} />
      )}
    </Box>
  );
};

export default DataStepsOne;
